"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
class AlreadyExistsError extends ExtendableError_1.default {
    constructor(key) {
        super(`The item with the key ${JSON.stringify(key)} already exists.`);
        this.key = key;
    }
}
exports.default = AlreadyExistsError;
